import React from 'react'
import { BigText } from '../components'

export const Phone = () => {
  return <BigText>No Connection To Bluetooth</BigText>
}
